import type { LayoutGraphicType } from './layoutTypes';

export type LayoutGraphicToolCategory = 'Text' | 'Lines' | 'Point' | 'Polygons' | 'Arrows';

export interface LayoutGraphicTool {
  readonly type: LayoutGraphicType;
  readonly label: string;
  readonly category: LayoutGraphicToolCategory;
  readonly gesture: 'point' | 'box' | 'vertices' | 'freehand' | 'threePoint' | 'fourPoint';
}

export const LAYOUT_GRAPHIC_TOOLS: readonly LayoutGraphicTool[] = [
  { type: 'rectangleText', label: 'Rectangle text', category: 'Text', gesture: 'box' },
  { type: 'polygonText', label: 'Polygon text', category: 'Text', gesture: 'vertices' },
  { type: 'straightText', label: 'Straight text', category: 'Text', gesture: 'vertices' },
  { type: 'curvedText', label: 'Curved text', category: 'Text', gesture: 'threePoint' },
  { type: 'circleText', label: 'Circle text', category: 'Text', gesture: 'box' },
  { type: 'ellipseText', label: 'Ellipse text', category: 'Text', gesture: 'box' },
  { type: 'line', label: 'Line', category: 'Lines', gesture: 'vertices' },
  { type: 'curvedLine', label: 'Curved line', category: 'Lines', gesture: 'fourPoint' },
  { type: 'freehandLine', label: 'Freehand line', category: 'Lines', gesture: 'freehand' },
  { type: 'arc', label: 'Three-point arc', category: 'Lines', gesture: 'threePoint' },
  { type: 'point', label: 'Point', category: 'Point', gesture: 'point' },
  { type: 'rectangle', label: 'Rectangle', category: 'Polygons', gesture: 'box' },
  { type: 'polygon', label: 'Polygon', category: 'Polygons', gesture: 'vertices' },
  { type: 'circle', label: 'Circle', category: 'Polygons', gesture: 'box' },
  { type: 'ellipse', label: 'Ellipse', category: 'Polygons', gesture: 'box' },
  { type: 'lasso', label: 'Lasso', category: 'Polygons', gesture: 'freehand' },
  { type: 'roundedRectangle', label: 'Rounded rectangle', category: 'Polygons', gesture: 'box' },
  { type: 'triangle', label: 'Triangle', category: 'Polygons', gesture: 'box' },
  { type: 'rightTriangle', label: 'Right triangle', category: 'Polygons', gesture: 'box' },
  { type: 'halfCircle', label: 'Half circle', category: 'Polygons', gesture: 'box' },
  { type: 'cross', label: 'Cross', category: 'Polygons', gesture: 'box' },
  { type: 'x', label: 'X', category: 'Polygons', gesture: 'box' },
  { type: 'cloud', label: 'Cloud', category: 'Polygons', gesture: 'box' },
  { type: 'arrow', label: 'Arrow', category: 'Arrows', gesture: 'vertices' },
  { type: 'curvedArrow', label: 'Curved arrow', category: 'Arrows', gesture: 'threePoint' },
  { type: 'doubleArrow', label: 'Double arrow', category: 'Arrows', gesture: 'vertices' },
  { type: 'curvedDoubleArrow', label: 'Curved double arrow', category: 'Arrows', gesture: 'fourPoint' },
] as const;

export const LAYOUT_GRAPHIC_CATEGORIES: readonly LayoutGraphicToolCategory[] =
  ['Text', 'Lines', 'Point', 'Polygons', 'Arrows'];

export function layoutGraphicTool(type: LayoutGraphicType): LayoutGraphicTool {
  return LAYOUT_GRAPHIC_TOOLS.find((tool) => tool.type === type) ?? LAYOUT_GRAPHIC_TOOLS[0];
}
